import { render, staticRenderFns } from "./nyjhDljy.vue?vue&type=template&id=25034392&scoped=true"
import script from "./nyjhDljy.vue?vue&type=script&lang=js"
export * from "./nyjhDljy.vue?vue&type=script&lang=js"
import style0 from "./nyjhDljy.vue?vue&type=style&index=0&id=25034392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25034392",
  null
  
)

export default component.exports